import { UserInformation } from '../../../api/_legacy/generated-api'
import { UserDisplayInfo, UserRole, UserType } from '../../../types/user'

const isUserInRole = (user, roleName: UserRole) => user?.roles?.includes(roleName)

export const isUserInRoles = (user, roleNames: UserRole[]) => {
  if (user && user.roles && user.roles.length > 0) {
    return roleNames.some(item => user.roles.includes(item))
  }
  return false
}

export const getUserType = (currentUser: UserInformation): UserType => {
  const isBusinessUnit = isUserInRoles(currentUser, ['Editor', 'BusinessUnitUser'])
  if (isBusinessUnit) {
    return 'business-unit'
  }
  const isClient = isUserInRole(currentUser, 'Client')
  if (isClient) {
    return 'client'
  }
  const isAbsaUser = isUserInRoles(currentUser, [
    'BankAdmin',
    'FLStructuring',
    'Operations',
    'Trading',
    'Sales',
    'RiskManagement',
    'PCT'
  ])
  if (isAbsaUser) {
    return 'absa'
  }
  const userType: UserType = isUserInRole(currentUser, 'Editor') ? 'business-unit' : 'admin'
  return userType
}

export const getUserRoles = (currentUser: UserInformation): UserRole[] => {
  if (currentUser && currentUser.roles && currentUser.roles.length > 0) {
    return currentUser.roles.map(item => item as UserRole)
  }
  return []
}

export const getUserDisplayInfo = (currentUser: UserInformation): UserDisplayInfo => {
  const userInfo: UserDisplayInfo = {
    firstName: currentUser?.firstName,
    lastName: currentUser?.lastName,
    userType: getUserType(currentUser),
    userRoles: getUserRoles(currentUser),
    userName: currentUser?.userName
  }
  return userInfo
}

export const isCollateralUser = (roles: UserRole[]) =>
  roles.includes('BankAdmin') || roles.includes('Administrator')
